import * as types from '../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";
import * as spinnerActions from '../spinnerActions';

export function loadServicesSuccess(services) {
    return {type: types.LOAD_SERVICES_SUCCESS, services};
}

export function deleteServiceSuccess(id) {
    return {type: types.DELETE_SERVICE_SUCCESS, id};
}

export function createServiceSuccess(service) {
    return {type: types.CREATE_SERVICE_SUCCESS, service};
}

export function updateServiceSuccess(service) {
    return {type: types.UPDATE_SERVICE_SUCCESS, service};
}

export function getServiceSuccess(service) {
    return {type: types.GET_SERVICE_SUCCESS, service};
}

export function cloneServiceSuccess(service) {
    return {type: types.CLONE_SERVICE_SUCCESS, service};
}

export function resetService() {
    return { type: types.RESET_SERVICE };
}

export function loadServices(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.get(`services?page=${page}`, null, sortParams).then(services => {
            dispatch(loadServicesSuccess(services));
        }).catch(error => {
            throw error;
        });
    }
}

export function getService(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('services', id).then(service => {
            dispatch(getServiceSuccess(service))
        }).catch(error => {
            throw error;
        });
    }
}

export function cloneService(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('services/clone', id).then(service => {
            dispatch(spinnerActions.hideSpinner());
            dispatch(cloneServiceSuccess(service));
        }).catch(error => {
            throw error;
        });
    }
}

export function deleteService(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('services', id).then(service => {
            dispatch(deleteServiceSuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

export function saveService(service) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create('services', service, true).then(service => {
            dispatch(createServiceSuccess(service));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateService(service, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update('services', id, service, true).then(service => {
            dispatch(updateServiceSuccess(service));
        }).catch(error => {
            throw error;
        })
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/services/servicesActions.js